module.exports = __webpack_public_path__ + "img/xbsys5.22e90d16.png";